<template>
  <div class="home">
<!--    <el-row class="header hidden-xs-only" >-->
<!--      <el-col>-->
<!--        <el-button class="header-item-login" @click="linkLogin('customer')">客户登录</el-button>-->
<!--        <el-button class="header-item-login" @click="linkLogin('clerk')">职员登录</el-button>-->
<!--      </el-col>-->
<!--    </el-row>-->
    <section class="section">
      <el-row class="input-box" type="flex" justify="center" >
        <el-col :xs="18" :sm="10" :md="10" :lg="10" :xl="10">
         <input class="input-search" v-model.trim="searchValue" type="text"
          @keyup.enter="getLogList"
          placeholder="请输入单号" />
        </el-col>
        <el-col :xs="6" :sm="3" :md="3" :lg="3" :xl="3">
          <el-button class="btn-search" @click="getLogList"  icon="el-icon-search">search</el-button>
        </el-col>
      </el-row>
      <el-row class="input-box" >
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
          <div v-if="isShowErr" class="err-text">请输入单号</div>
        </el-col>
      </el-row>
      <!----PC端---->
      <div class="query-box hidden-sm-and-down">
        <table class="result-info" cellspacing="0" v-if="logList.length>0">
          <thead>
            <tr>
              <th>时间(timeNode)</th>
              <th>progress</th>
              <th>地点和跟踪进度</th>
            </tr>
          </thead>
          <tbody>
            <tr :class="{'last':index == 0}" v-for="(item,index) in logList"
              :key="index">
              <td class="row1">
                <span class="day">{{item.timeDot}}</span>
              </td>
              <td class="contex" t="">{{item.processEn}}</td>
              <td class="contex" t="">{{item.processZh}}</td>
            </tr>
          </tbody>
        </table>
        <template v-if="logList.length == 0">
          <div v-if="loading" class="result-info-err">查询中...</div>
          <div v-else-if="notSearched" class="result-info-err">请输入待查询单号</div>
          <div v-else class="result-info-err">{{errMassage}}</div>
        </template>
      </div>
      <!---手机端---->
      <div class="query-box-ms hidden-sm-and-up">
        <el-row class="query-box-ms-item"  v-for="(item,index) in logList"   :key="index">
          <el-col  :class="{'last':index == 0}" :xs="24" :sm="7" :md="7" :lg="7" :xl="7">
            <span class="day">{{item.timeDot}}</span>
          </el-col>
          <el-col :class="{'last':index == 0}"  :xs="24" :sm="7" :md="7" :lg="7" :xl="7">
            <span class="contex">{{item.processEn}}</span>
          </el-col>
          <el-col :class="{'last':index == 0}"  :xs="24" :sm="7" :md="7" :lg="7" :xl="7">
            <span class="contex">{{item.processZh}}</span>
          </el-col>
       </el-row>
       <el-row v-if="logList.length == 0">
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <div v-if="loading" class="result-info-err">查询中...</div>
            <div v-else-if="notSearched" class="result-info-err">请输入待查询单号</div>
            <div v-else class="result-info-err">{{errMassage}}</div>
        </el-col>
       </el-row>
      </div>
    </section>
  </div>
</template>

<script>
import {homeApi } from '@/service'
export default {
  name: 'Home',
  data() {
    return {
      isShowErr: false,
      searchValue: '',
      logList: [],
      notSearched: true,
      loading: false,
      errMassage:'该单号暂无物流轨迹信息',
      order_code:'',
      trans_code:'',
    }
  },
  methods: {
    getLogList() {
      if (this.searchValue == '') {
        this.isShowErr = true;
      } else {
        this.isShowErr = false;
      }
      let params = {
        orderCode: this.searchValue
      }
      this.loading = true
      this.notSearched = false
      homeApi.logList(params).then(res => {
        if(!res.data){
            this.logList = [];
            this.errMassage = res.massage || "该单号暂无物流轨迹信息";
        }else{
          res.data.forEach(item => item.timeDot = new Date(item.timeDot).format("yyyy-MM-dd hh:mm:ss"))
          this.order_code = res.order_code || '';
          this.trans_code = res.trans_code || '';
          this.logList = res.data;
        }
        this.loading = false

      }).catch((error) => {
        this.loading = false
        console.log(error);
      })
    },
    //跳转到登录页面
    linkLogin(tag){
      this.$router.push({name:'login',query:{tag:tag}})
    }
  }
}
</script>

<style lang="less" scoped>
.home {
  width: 100%;
  height: 100vh;
  position: relative;
  //background: url(../assets/images/bg.jpg) no-repeat;
  background-image: linear-gradient(180deg, blue 20%, #ffffff 50%);
}
.header {
  text-align: right;
  width: 100%;
  .header-item-login{
    background:orange;
    border:1px solid orange;
    color:#fff;

  }
}
.input-box {
  text-align: center;
  margin: auto
}
.flex-display{
  display:flex;
  flex-wrap: nowrap;
  justify-content:space-between;
}
.input-search {
  padding: 9px 10px;
  width: 100%;
  height: 60px;
  line-height: 38px;
  font-size: 16px;
  -webkit-appearance: none;
  border-radius: 0px;
  border: 1px solid #ffffff;
  border-left: 1px solid #d2d2d2;
  border-top-left-radius:5px;
  border-bottom-left-radius:5px;
}
.btn-search {
  display: inline-block;
  padding: 0;
  width: 100%;
  height: 60px;
  line-height: 54px;
  font-size: 18px;
  color: #fff;
  vertical-align: top;
  border-top-right-radius:5px;
  border-bottom-right-radius:5px;
  background-color: #ff7800;
}
.err-text {
  width: 100%;
  text-align: center;
  color: #e4393c;
}
.section {
  clear: both;
  min-height: 500px;
  height: auto;
  background-color: rgba(228, 220, 220, 0.1);
  width: 100%;
  padding: 20px 0px;
}
.result-top {
  width: 1300px;
  height: 43px;
  background-color: #ffffff;
  border-bottom: none;
}
.result-top .col1 {
  width: 200px;
  text-align: left;
  color: #323232;
  font-size: 16px;
}
.result-top span,
.result-top a {
  display: inline-block;
  height: 43px;
  line-height: 43px;
  vertical-align: middle;
  font-size: 14px;
}
.result-top .col2,
.result-top .col3 {
  width: 450px;
  text-align: left;
  font-size: 16px;
  color: #5a5a5a;
  padding-left: 50px;
}
.order-info{
  width:100%;
  margin:0 auto;
  margin-top:100px;
  text-align: center;
}
.query-box {
  box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
  width: 1300px;
  height: auto;
  min-height: 500px;
  max-height: 700px;
  overflow-y: auto;
  text-align: left;
  margin: 40px auto;
  background-color: #fff;
  border-radius: 12px;
  padding: 15px 0px;
}
.query-box:hover{
  box-shadow: 0 2px 12px 0 rgba(0,0,0,.15)
}
.result-info {
  border-collapse: collapse;
  border-spacing: 0;
  width: 1300px;
  min-height: 100px;
}
.result-info .last td,
.result-info .last td a {
  color: #ff7800;
  border-bottom: none;
}
.result-info .row1 {
  width: 200px;
  text-align: left;
  padding-right: 0;
}
.result-info th,
.result-info td {
  padding: 15px 25px;
  color: #828282;
}
.result-info-err {
  width: 100%;
  margin: 0 auto;
  padding-top: 200px;
  text-align: center;
}
th:first-child,
td:first-child {
  border-right: 1px dotted #000;
}
th:last-child,
td:last-child {
  border-left: 1px dotted #000;
}
.query-box-ms-item{
  padding:8px;
  text-align:center;
  margin-top:10px;
}
.query-box-ms{
  min-height:500px;
  max-height:9000px;
  height:100%;
  overflow-y:auto !important;

}
.query-box-ms-item .last {
  color: yellow !important;
}
</style>
